/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateViewRequest
 */
export interface UpdateViewRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateViewRequest
   */
  savedViewId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateViewRequest
   */
  columnConfig: string;
  /**
   *
   * @type {string}
   * @memberof UpdateViewRequest
   */
  filters: string;
}

/**
 * Check if a given object implements the UpdateViewRequest interface.
 */
export function instanceOfUpdateViewRequest(
  value: object,
): value is UpdateViewRequest {
  if (!("savedViewId" in value) || value["savedViewId"] === undefined)
    return false;
  if (!("columnConfig" in value) || value["columnConfig"] === undefined)
    return false;
  if (!("filters" in value) || value["filters"] === undefined) return false;
  return true;
}

export function UpdateViewRequestFromJSON(json: any): UpdateViewRequest {
  return UpdateViewRequestFromJSONTyped(json, false);
}

export function UpdateViewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateViewRequest {
  if (json == null) {
    return json;
  }
  return {
    savedViewId: json["savedViewId"],
    columnConfig: json["columnConfig"],
    filters: json["filters"],
  };
}

export function UpdateViewRequestToJSON(json: any): UpdateViewRequest {
  return UpdateViewRequestToJSONTyped(json, false);
}

export function UpdateViewRequestToJSONTyped(
  value?: UpdateViewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedViewId: value["savedViewId"],
    columnConfig: value["columnConfig"],
    filters: value["filters"],
  };
}
